import { ShoppingCartItems } from '@/modules/moduleSubscription/types/ShoppingCart'
import WebStorageService from '@/modules/_services/webstorage.service'
import WebStorageKey from '@/enums/web-storage-key.enum'
import { handleDeleteForGtm } from './gtmHandlers'

export const removeItemFromCart = (
  type: string,
  itemName: string,
  items: ShoppingCartItems,
  enableItemsFromStorage?: boolean,
) => {
  const itemsCount = items
  const count = itemsCount?.[type]?.[itemName]?.count ? itemsCount[type][itemName].count : 0
  if (count > 0) {
    handleDeleteForGtm(type, items[type][itemName])
  }

  const updatedItems = { ...items }
  const { [itemName]: _, ...newItemsOfType } = updatedItems[type]
  updatedItems[type] = newItemsOfType
  if (enableItemsFromStorage) WebStorageService.setItem(WebStorageKey.SHOPPING_CART, { items: updatedItems })
}
